import axios from 'axios'

import { defaultExternalEnvironmentVariables, ExternalEnvironmentVariables } from './environment-variables'

export const getConfig = (baseUrl: string): Promise<ExternalEnvironmentVariables> =>
  process.env.NODE_ENV === 'development'
    ? Promise.resolve(defaultExternalEnvironmentVariables)
    : axios.get<ExternalEnvironmentVariables>(`${baseUrl}/config.json`).then(({ data }) => data)
